import { useTranslation } from 'react-i18next'

import { Switch, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const BlockSettingBooleanField = ({ field, value, onChange }) => {
  const { t } = useTranslation()

  const handleChange = event => onChange(field.key, event.target.checked)

  return (
    <Styles.Container>
      <Styles.Label>
        <Text type="bodyMRegular">{t(field.label)}</Text>
        <Styles.Helper type="bodySRegular">{t(field.helper)}</Styles.Helper>
      </Styles.Label>
      <Switch checked={value} onChange={handleChange} />
    </Styles.Container>
  )
}

export default BlockSettingBooleanField
